import * as types from './mutation-types'

export default {
  [types.SET_DADOS_CARRINHO] (state, dadosCarrinho) {
    state.itens = dadosCarrinho.itens
  },
  [types.LIMPAR_DADOS_CARRINHO] (state) {
    state.itens = []
  },
  [types.SET_ADICIONAR_ITEM_CARRINHO] (state, item) {
    const listaItensModificado = [...state.itens, item]
    state.itens = listaItensModificado
  },
  [types.REMOVER_ITEM_CARRINHO] (state, { item, indice }) {
    const listaItensModificado = state.itens.filter((_, i) => i !== indice)
    state.itens = listaItensModificado
  },
  [types.AUMENTAR_QUANTIDADE_ITEM_CARRINHO] (state, { item, indice }) {
    const listaItensModificado = state.itens.map((item, i) =>
      i === indice ? { ...item, produto: { ...item.produto, quantidade: item.produto.quantidade + 1 } } : item
    )
    state.itens = listaItensModificado
  },
  [types.DIMINUIR_QUANTIDADE_ITEM_CARRINHO] (state, { item, indice }) {
    const listaItensModificado = state.itens.map((item, i) =>
      i === indice && item.produto.quantidade > 1 ? { ...item, produto: { ...item.produto, quantidade: item.produto.quantidade - 1 } } : item
    )
    state.itens = listaItensModificado
  },
  [types.SET_CUPOM_DATA_DO_CARRINHO] (state, cupom) {
    state.cupomData = cupom
  }
}
